import styles from './styles.module.scss'
import React, { useEffect, useState } from 'react'
import "@/src/extensions/number"
import { useMerchant } from '@/src/context/merchant/merchant-context';
import ImageFallback from '@/src/components/helpers/image-fallback/image-fallback';
import Items from '@/src/interfaces/catalog/items';
import { usePromotion } from '@/src/context/promotion/promotion-context';
import { PromotionHelper } from '@/src/helpers/promotion';
import { ProductTypeId } from '@/src/hooks/product/useWizard';
import SvgSale from '@/src/assets/svgs/collection/sale.svg'
import { useCategory } from '@/src/context/category/category-context';

interface ProductCardProps {
    product: Items.ItemResponse
    setProduct(product: Items.ItemResponse): void
}

export default function ProductCard({ product, setProduct }: ProductCardProps) {
    const { merchantSummary } = useMerchant()
    const [currentProduct, setCurrentProduct] = useState<Items.ItemResponse>()
    const { promotion } = usePromotion()
    const { categoriesBySearch } = useCategory()

    useEffect(() => { setCurrentProduct(product) }, [product])

    if (!currentProduct)
        return <></>

    const imgSrc = (currentProduct.hasPhoto && currentProduct.smallImageUrl && merchantSummary?.showProductPhoto) ? `//${product?.smallImageUrl}` : undefined
    const promotionProduct = PromotionHelper.getProduct(promotion, currentProduct.id)
    const isSearch = categoriesBySearch?.categories && categoriesBySearch.categories.length > 0

    const renderPrice = () => {
        if (currentProduct.itemTypeId === ProductTypeId.ProductBySize && !promotionProduct) {
            return (
                <span className={`${styles.from} ${styles.price}`}><label>A partir de </label>{currentProduct.minPrice.toLocalePrice()}</span>
            )
        }

        if (currentProduct.itemTypeId === ProductTypeId.ProductBySize && promotionProduct) {
            return (
                <span className={`${styles.from} ${styles.price}`}><label>A partir de </label><b>{PromotionHelper.getFromToPrice(promotion, { ...currentProduct, salePrice: currentProduct.minPrice } as Items.ItemResponse).to.toLocalePrice()}</b></span>
            )
        }

        if (promotionProduct) {
            const promoPrice = PromotionHelper.getFromToPrice(promotion, currentProduct as Items.ItemResponse);
            const from = promoPrice.from.toLocalePrice()
            const to = promoPrice.to.toLocalePrice()
            if (currentProduct.salePrice) {
                return (
                    <span className={`${styles.from} ${styles.price}`}><label>De <s>{from}</s> por </label><b>{to}</b></span>
                )
            }
            else if (currentProduct.minPrice) {
                return (
                    <span className={`${styles.from} ${styles.price}`}><label>A partir de <s>{from}</s> por </label><b>{to}</b></span>
                )
            }
        }
        else {
            if (currentProduct.salePrice) {
                return (
                    <b className={styles.price}>{currentProduct.salePrice.toLocalePrice()}</b>
                )
            }
            else if (currentProduct.minPrice) {
                return (
                    <span className={`${styles.from} ${styles.price}`}><label>A partir de </label>{currentProduct.minPrice.toLocalePrice()}</span>
                )
            }
        }

        return (
            <span className={styles.price}>&nbsp;</span>
        )
    }

    return (
        <div onClick={() => setProduct(currentProduct)} className={styles.card} style={isSearch ? { height: 'auto', padding: '12px 0' } : {}}>
            <div className={styles.imageArea}>
                {promotionProduct && <SvgSale className={styles.svgSales} />}
                <ImageFallback
                    className={styles.itemPromotionImage}
                    src={imgSrc}
                    alt={currentProduct.name}
                />
            </div>
            <div className={styles.contentDescription} style={isSearch ? { height: 'auto' } : {}}>
                <h5 className={`${styles.title} font-md`}>{currentProduct.name}</h5>
                <p className={`${styles.description} ${isSearch ? styles.showDescription : ''} font-sm`}>
                    {merchantSummary?.showProductDescription ? currentProduct.description : ''}
                </p>
                <b className={styles.price}>
                    {merchantSummary?.showProductPrice ? renderPrice() : ''}
                </b>
            </div>
        </div>
    )
}
